import Const from '@/helper/const'
import { custAxios } from './genericApi'

export default {
  newConsult (params) {
    return custAxios().post(Const.API_CALLMANAGER, params)
  },
  getAllConsults (params) {
    return custAxios().get(`${Const.API_CALLMANAGER}/relatorioFiltroNomeECpfResumido/${params.idProviderFlow}`, { params })
  },
  cancelSchedule (params) {
    return custAxios().put(`${Const.API_SCHEDULE_CM}/agendar?id=${params.id}&idUser=${params.idUser}&nameUser=${params.nameUser}`)
  },
  getScheduledCallManagerInfo (idCallManager) {
    return custAxios().get(`${Const.API_SCHEDULE_CM}/consultasPorCallmanager?idCallManager=${idCallManager}`)
  },
  reprocessCallManager (params) {
    return custAxios().put(`${Const.API_CALLMANAGER}/${params.idCallManager}`, params.body)
  },
  getPreviousScheduledCallManagersInfo (idCallManager) {
    return custAxios().get(`${Const.API_CALLMANAGER}/history/${idCallManager}`)
  },
  getHierarchicalCallManagerDetails (idCallManager) {
    return custAxios().get(`${Const.API_CALLMANAGER}/hierarchy/${idCallManager}`)
  }
}
